// Copyright (c) Jupyter Development Team.
// Copyright (c) Microsoft Corporation.
// Distributed under the terms of the Modified BSD License.
import { css } from '@microsoft/fast-element';
import { display } from '@microsoft/fast-foundation';
import { density, designUnit, typeRampBaseFontSize, typeRampBaseLineHeight } from '../design-tokens.js';
/**
 * Styles for Tab Panel
 * @public
 */
export const tabPanelStyles = (context, definition) => css `
  ${display('block')} :host {
    box-sizing: border-box;
    font-size: ${typeRampBaseFontSize};
    line-height: ${typeRampBaseLineHeight};
    padding: 0 calc((6 + (${designUnit} * 2 * ${density})) * 1px);
  }
`;
